import React from "react";
import DownloadLink from "../../../components/global/components/DownloadLink";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

// CDN base URL
const CDN_BASE_URL = "https://cdncollegementor.blob.core.windows.net/scholarship/eventsPage/";

// Define a placeholder logo for fallback
const placeholderLogo = "/images/placeholder-logo.png";

// Define institutions array with all colleges using CDN images
const institutions = [
  {
    name: "Aditya University",
    logo: `${CDN_BASE_URL}Aditya university_Final_02.webp`,
    slug: "aditya-university-kakinada",
    alt: "Aditya University",
  },
  {
    name: "Dr. MGR University",
    logo: `${CDN_BASE_URL}Dr. M.G.R. Educational and Research Institute_2.webp`,
    slug: "dr-mgr-educational-and-research-institute-chennai",
    alt: "Dr. MGR University",
  },
  {
    name: "Dhanalakshmi Srinivasan University",
    logo: `${CDN_BASE_URL}dhanalakshmi srinivasan university.webp`,
    slug: "dhanalakshmi-srinivasan-university-tiruchirappalli",
    alt: "Dhanalakshmi Srinivasan University",
  },
  {
    name: "Bharath Institute of Higher Education and Research",
    logo: `${CDN_BASE_URL}bharath university logo.webp`,
    slug: "biher-bharath-institute-of-higher-education-and-research-chennai",
    alt: "Bharath Institute of Higher Education and Research",
  },
  {
    name: "Manav Rachana University",
    logo: `${CDN_BASE_URL}manav rachn.webp`,
    slug: "mriirs-faridabad-manav-rachna-international-institute-of-research-and-studies-faridabad",
    alt: "Manav Rachana University",
  },
  {
    name: "Intellipaat",
    logo: `${CDN_BASE_URL}WhatsApp Image 2025-05-03 at 3.43.27 PM.webp`,
    slug: "#",
    alt: "Intellipaat",
  },
  {
    name: "Akash Group of Institutions",
    logo: `${CDN_BASE_URL}akasha group of instute bangalour.webp`,
    slug: "#",
    alt: "Akash Group of Institutions",
  },
  {
    name: "Kaveri University",
    logo: `${CDN_BASE_URL}Kaveri University_02.webp`,
    slug: "kaveri-university-siddipet",
    alt: "Kaveri University",
  },
  {
    name: "GITAM deemed to be University",
    logo: `${CDN_BASE_URL}GITAM_logo.webp`,
    slug: "gitam-gandhi-institute-of-technology-and-management",
    alt: "GITAM deemed to be University",
  },
  {
    name: "S VYASA University",
    logo: `${CDN_BASE_URL}SVYASA-New-Logo-Main.webp`,
    slug: "s-vyasa-university-global-city-campus-bengaluru",
    alt: "S VYASA University",
  },
  {
    name: "Jain University",
    logo: `${CDN_BASE_URL}Jain University.webp`,
    slug: "jain-deemed-to-be-university-bangalore",
    alt: "Jain University",
  },
  {
    name: "Quantum University",
    logo: undefined,
    slug: "quantum-university-roorkee",
    alt: "Quantum University",
  },
  {
    name: "Anurag University",
    logo: `${CDN_BASE_URL}anurag-university-seeklogo.webp`,
    slug: "anurag-university-hyderabad",
    alt: "Anurag University",
  },
  {
    name: "GLA University",
    logo: `${CDN_BASE_URL}GLA.webp`,
    slug: "gla-university-mathura",
    alt: "GLA University",
  },
  {
    name: "Harsha Institutions",
    logo: `${CDN_BASE_URL}harsha group university.webp`,
    slug: "#",
    alt: "Harsha Institutions",
  },
  {
    name: "Hindustan Institute of Technologies",
    logo: `${CDN_BASE_URL}Hindustan.webp`,
    slug: "hits-chennai-hindustan-institute-of-technology-and-science-chennai",
    alt: "Hindustan Institute of Technologies",
  },
  {
    name: "IES University",
    logo: `${CDN_BASE_URL}IES university-1.webp`,
    slug: "ies-university-bhopal",
    alt: "IES University",
  },
  {
    name: "ITM University",
    logo: `${CDN_BASE_URL}itm.webp`,
    slug: "itm-gwalior-itm-institute-of-technology-and-management-gwalior",
    alt: "ITM University",
  },
  {
    name: "IILM University",
    logo: `${CDN_BASE_URL}iilm university gurugram LOGO.webp`,
    slug: "iilm-university-gurugram",
    alt: "IILM University",
  },
  {
    name: "Indus University",
    logo: `${CDN_BASE_URL}Indus University.webp`,
    slug: "indus-university-ahmedabad",
    alt: "Indus University",
  },
  {
    name: "Jeppiar University",
    logo: `${CDN_BASE_URL}WhatsApp Image 2025-05-03 at 3.43.27 PM.webp`,
    slug: "jeppiaar-university-chennai",
    alt: "Jeppiar University",
  },
  {
    name: "Joy University",
    logo: undefined,
    slug: "#",
    alt: "Joy University",
  },
  {
    name: "Malla Reddy University",
    logo: `${CDN_BASE_URL}Malla Reddy University_02.webp`,
    slug: "malla-reddy-university-hyderabad",
    alt: "Malla Reddy University",
  },
  {
    name: "Malla Reddy Vishwa Vidhyapeeth",
    logo: `${CDN_BASE_URL}Malla Reddy University_03.webp`,
    slug: "#",
    alt: "Malla Reddy Vishwa Vidhyapeeth",
  },
  {
    name: "Marwadi University",
    logo: undefined,
    slug: "marwadi-university-rajkot",
    alt: "Marwadi University",
  },
  {
    name: "NxT Wave",
    logo: `${CDN_BASE_URL}next wave institute.webp`,
    slug: "#",
    alt: "NxT Wave",
  },
  {
    name: "P P Savani University",
    logo: `${CDN_BASE_URL}PPSU.webp`,
    slug: "pp-savani-university-surat",
    alt: "P P Savani University",
  },
  {
    name: "Presidency University",
    logo: `${CDN_BASE_URL}Presidency College_02.webp`,
    slug: "presidency-university-bangalore",
    alt: "Presidency University",
  },
  {
    name: "Sage University",
    logo: `${CDN_BASE_URL}SAGE.webp`,
    slug: "sage-university-indore",
    alt: "Sage University",
  },
  {
    name: "Sai University",
    logo: `${CDN_BASE_URL}SAI Logo - SAIlogo copy.webp`,
    slug: "sai-university-chennai",
    alt: "Sai University",
  },
  {
    name: "Sharda University",
    logo: `${CDN_BASE_URL}sharda university.webp`,
    slug: "sharda-university-greater-noida",
    alt: "Sharda University",
  },
  {
    name: "SRU",
    logo: `${CDN_BASE_URL}Sr University_01.webp`,
    slug: "#",
    alt: "SRU",
  },
  {
    name: "Sri Sri University",
    logo: `${CDN_BASE_URL}Sri Sri University.webp`,
    slug: "sri-sri-university-cuttack",
    alt: "Sri Sri University",
  },
  {
    name: "Sunstone",
    logo: undefined,
    slug: "#",
    alt: "Sunstone",
  },
  {
    name: "Sanskriti University",
    logo: `${CDN_BASE_URL}Sanskriti_University_logo (1).webp`,
    slug: "sanskriti-university-mathura",
    alt: "Sanskriti University",
  },
  {
    name: "Takshashila University",
    logo: `${CDN_BASE_URL}Takshashila University_01.webp`,
    slug: "takshashila-university-tindivanam",
    alt: "Takshashila University",
  },
  {
    name: "Uttaranchal University",
    logo: `${CDN_BASE_URL}Uttaranchal.webp`,
    slug: "uttaranchal-university-dehradun",
    alt: "Uttaranchal University",
  },
  {
    name: "Vishwa Vishwani",
    logo: `${CDN_BASE_URL}VVISM-CL-1-1.webp`,
    slug: "vishwa-vishwani-school-of-business-hyderabad",
    alt: "Vishwa Vishwani",
  },
  {
    name: "Planet Finance Business School",
    logo: undefined,
    slug: "vvit-guntur-vasireddy-venkatadri-institute-of-technology-guntur",
    alt: "Planet Finance Business School",
  },
  {
    name: "Sri Padampat Singhania University",
    logo: undefined,
    slug: "spsu-udaipur-sir-padampat-singhania-university-udaipur",
    alt: "Sri Padampat Singhania University",
  },
  {
    name: "Institute of Venture Building Pvt Ltd",
    logo: undefined,
    slug: "joy-university-vadakkankulam",
    alt: "Institute of Venture Building Pvt Ltd",
  },
  {
    name: "KL University",
    logo: `${CDN_BASE_URL}KL_University_logo.webp`,
    slug: "kl-university-guntur-koneru-lakshmaiah-education-foundation-guntur",
    alt: "KL University",
  },
];

const ParticipationProcedure = () => {
  const location = useLocation();
  
  return (
    <div className="w-full max-md:w-full flex flex-row max-lg:flex-col bg-white md:gap-7 md:container my-[9px]">
      {/* Left Content Section */}
      <div className="w-3/5 max-lg:w-full">
        <div className=" bg-[#E2F3FF]  pl-6 md:pr-10 pt-10 pb-6 flex flex-col max-md:px-5">
          <h3 className="text-5xl font-bold max-md:text-[32px] leading-[27px] text-[#173CBA] mb-6">
            Participation Procedure
          </h3>

          <div className="gap-5 text-[#383838] flex flex-col ">
            <div>
              <h3 className="text-[24px] font-bold leading-[27px]">
                Expression of Interest
              </h3>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                We warmly invite you to express your interest in participating
                in College Mentor India's premier Admission and Scholarship Fair
                2025 - a prestigious platform to enhance your institution's
                visibility, connect with India's brightest students, and
                contribute to building a Viksit Bharat through Quality
                Education, Scholarships, Admissions, and Mentorship.
              </p>
              <p className="text-[16px] font-normal leading-[27px] pt-2">
                Reach out to us at scholarship@collegementor.com to submit your
                interest
              </p>
            </div>

            <div>
              <h3 className="text-[24px] font-bold leading-[27px]">
                Select Your Participation Category
              </h3>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                Choose the sponsorship or participation tier that aligns best
                with your institution's branding.(To know about categories in
                detail{" "}
                <DownloadLink
                  href="/pdf/College-Mentor-Scholarship-Fair-2025-University-Partnership-Brochure.pdf"
                  download="College-Mentor-Scholarship-Fair-2025-University-Partnership-Brochure.pdf"
                  className="text-[#173CBA]"
                  autoDownload={!!location.state?.downloadRequested} // Automatically download if redirected after login
                >
                  download our brochure here
                </DownloadLink>
                )
              </p>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                Each category is designed with tailored branding opportunities
                maximizing your visibility before, during, and after the event.
              </p>
            </div>

            <div>
              <h3 className="text-[24px] font-bold leading-[27px]">
                Complete Registration Formalities
              </h3>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                Upon selecting your preferred participation tier, Submit your
                completed registration form.(
                <DownloadLink
                  href="/pdf/CollegeMentor-Sponsorship-Exhibitor-Registration-Form.pdf"
                  download="CollegeMentor-Sponsorship-Exhibitor-Registration-Form.pdf"
                  className="text-[#173CBA]"
                  autoDownload={!!location.state?.downloadRequested} // Automatically download if redirected after login
                >
                  Download here
                </DownloadLink>
                )
              </p>
            </div>

            <div>
              <h3 className="text-[24px] font-bold leading-[27px]">
                Invoice Generation & Formal Confirmation
              </h3>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                Following your confirmation an official invoice will be raised
                and sent to your designated point of contact.
              </p>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                On payment receipt, your participation will be officially
                confirmed, and onboarding for sponsorship deliverables will
                commence.
              </p>
            </div>

            <div>
              <h3 className="text-[24px] font-bold leading-[27px]">
                Submission of Promotional Materials
              </h3>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                To optimize your visibility across all promotional platforms, we
                request the submission of the following assets, Institution
                Profile and Brochures, Promotional Videos, Course Highlights,
                High-Resolution Branding Materials
              </p>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                These materials will be deployed across digital promotions,
                print campaigns, PR activities, and event-day branding setups.
              </p>
            </div>

            <div>
              <h3 className="text-[24px] font-bold leading-[27px]">
                Pre-Event Promotions
              </h3>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                Upon receiving your promotional materials, College Mentor will
                start working on all the deliverables as promised based on the
                sponsorship type.
              </p>
              <p className="text-[16px] font-normal leading-[27px] mt-2"></p>
            </div>

            <div>
              <h3 className="text-[24px] font-bold leading-[27px]">
                Active Participation on Event Day
              </h3>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                On the day of the event, institutions are expected to come 3
                hours before the actual time and Set up their allotted stalls,
                Engage with students, parents, and educators, Offer academic
                guidance, admissions advice, and scholarship opportunities,
                Strengthen brand loyalty among the next generation of leaders.
              </p>
            </div>

            <div>
              <h3 className="text-[24px] font-bold leading-[27px]">
                Post-Event Acknowledgments
              </h3>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                Participants will be featured on our platforms even after the
                event with Special mentions across social media, Coverage in
                post-event newsletters and reports.
              </p>
              <p className="text-[16px] font-normal leading-[27px] mt-2">
                For any queries, clarification, or support, Reach us at:
                scholarship@collegementor.com
              </p>
            </div>
          </div>
        </div>
        <div className="bg-[#E9F3EE] px-6 py-6">
          <h3 className="text-[#383838] text-[24px] font-bold leading-[27px] ">
            Account Details
          </h3>
          <div className="mt-2 text-[#383838] font-normal text-[16px]  leading-[27px] ">
            <p className="mt-1 font-bold">Dreams and Degrees Edutech Pvt Ltd</p>
            <p className="mt-1">HDFC BANK LTD</p>
            <p className="mt-1">A/C No: 99901357899999 / IFSC: HDFC0002083</p>
            <p className="mt-1">GST NO: 36AAKCD5157E1ZM</p>
            <p className="mt-4 font-normal">
              For any queries, clarification, or support, Reach us at:
              <span>scholarship@collegementor.com</span>
            </p>
          </div>
        </div>
      </div>

      {/* Right Content - Participating Institutions */}
      <div className="w-2/5 bg-[#F7F7F7] flex flex-col max-lg:w-full max-md:px-5 sticky top-0 h-screen">
        <h3 className="text-[#173CBA] text-[40px] max-md:text-[32px] font-light text-center py-8">
          Participating <span className="font-bold">Institutions</span>
        </h3>

        <div className="grid grid-cols-1 gap-4 overflow-y-auto px-4 pb-6 flex-1" style={{ maxHeight: 'calc(100vh - 120px)' }}>
          {institutions
            .filter(institution => institution.logo)
            .map((institution, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md p-4 border border-transparent hover:border-[#173CBA] transition-all duration-200"
              >
                {institution.slug && institution.slug !== "#" ? (
                  <Link
                    to={`/college-details/${institution.slug}`}
                    className="flex items-center gap-4"
                  >
                    <div className="w-[120px] h-[70px] border border-[#E5E5E5] rounded bg-white flex items-center justify-center p-2 flex-shrink-0">
                      <img
                        src={institution.logo}
                        alt={institution.alt}
                        className="max-w-full max-h-full object-contain"
                        onError={(e) => {
                          e.currentTarget.src = placeholderLogo;
                        }}
                      />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-[#383838] text-base font-semibold leading-tight">
                        {institution.name}
                      </h3>
                    </div>
                  </Link>
                ) : (
                  <div className="flex items-center gap-4">
                    <div className="w-[120px] h-[70px] border border-[#E5E5E5] rounded bg-white flex items-center justify-center p-2 flex-shrink-0">
                      <img
                        src={institution.logo}
                        alt={institution.alt}
                        className="max-w-full max-h-full object-contain"
                        onError={(e) => {
                          e.currentTarget.src = placeholderLogo;
                        }}
                      />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-[#383838] text-base font-semibold leading-tight">
                        {institution.name}
                      </h3>
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ParticipationProcedure;
